<template>
<div>
  <h4 class="text-center">
    <i class="fas fa-file-alt mr-2" aria-hidden="true"></i>
     
  ID ORDINE - [{{orderId}}] - 
  COLLEZIONE <strong>{{ orderData.collection }}</strong> ---
  <strong> {{orderData.supplier}}  - n.ro {{orderData.order_num}}  del {{orderData.order_date}} -
        {{orderData.store}} 
         </strong>
     
  </h4>      

</div>
</template>
<script>


import api                 from '@/api';

export default {
   components: {},  
    props  : ['orderId'],
  data () 
  {
    return {

    orderData : {}

    }
    
    },
  computed : {
     

     },
   created () 
    {
      
        this.getData()
     
    },
  methods: {
    async getData()
    {
        const sp = 'spOrderHeaderCollection'
        const payload  = {'orderId' :this.orderId,sp}       
      
         try{

         const res = await api.post(payload)
         if (res.status !== 200) 
          {
              throw new Error(res.data ||  res)
          }
          
              this.orderData = res.data.recordsets[0][0]                       
                            
          
        }catch(err)
        {
              //this.$refs.msgModal.show(err.message)
        }
    






        
  }

  }
}
</script>

<style scoped>
 h4 {
  font-family : 'Roboto Condensed';
  font-size   : 20px;
   }
</style>
